import { useContext } from 'react';
import Notification from '../context/notification';

function useNotification() {
  return useContext(Notification);
}

export default useNotification;
